import React from "react";
import { C } from "../constants/baziData";

const SIHUA_LABELS = { "化禄": "禄", "化权": "权", "化科": "科", "化忌": "忌" };
const SIHUA_COLORS = {
  "化禄": { bg: "#D1FAE5", color: "#065F46" },
  "化权": { bg: "rgba(212,175,55,.15)", color: "#78450A" },
  "化科": { bg: "#DBEAFE", color: "#1E40AF" },
  "化忌": { bg: "#FEE2E2", color: "#991B1B" },
};

function SihuaBadge({ sihua }) {
  const col = SIHUA_COLORS[sihua] || { bg: "rgba(0,0,0,.06)", color: "#333" };
  return (
    <span style={{
      fontSize: 9, fontFamily: "sans-serif",
      padding: "1px 5px", borderRadius: 4,
      background: col.bg, color: col.color,
      fontWeight: 700, marginLeft: 3,
    }}>{SIHUA_LABELS[sihua] || sihua}</span>
  );
}

function PalaceCard({ palace, narrative, lang }) {
  const isMing = palace.is_ming_gong;
  const isShen = palace.is_shen_gong;
  const isSpecial = isMing || isShen;

  const mainStars = palace.stars || [];
  const auxStars  = palace.aux_stars || [];
  const shaStars  = palace.sha_stars || [];
  const sihua     = palace.sihua_here || [];

  return (
    <div style={{
      padding: 12,
      borderRadius: 10,
      border: isSpecial
        ? `1.5px solid ${C.gold}`
        : "1px solid rgba(212,175,55,.18)",
      background: isSpecial
        ? "rgba(212,175,55,.06)"
        : "white",
      position: "relative",
    }}>
      {/* Palace name */}
      <div style={{
        display: "flex", justifyContent: "space-between",
        alignItems: "flex-start", marginBottom: 6,
      }}>
        <span style={{
          fontSize: 13, fontWeight: 700,
          color: isSpecial ? "#846B32" : "#4A3A2A",
        }}>{palace.palace_name || "—"}</span>
        <div style={{ display: "flex", gap: 3 }}>
          {isMing && (
            <span style={{
              fontSize: 9, padding: "1px 5px", borderRadius: 4,
              background: "rgba(212,175,55,.25)", color: "#846B32",
              fontFamily: "sans-serif", fontWeight: 700,
            }}>命</span>
          )}
          {isShen && (
            <span style={{
              fontSize: 9, padding: "1px 5px", borderRadius: 4,
              background: "rgba(59,130,246,.15)", color: "#1E40AF",
              fontFamily: "sans-serif", fontWeight: 700,
            }}>身</span>
          )}
        </div>
      </div>

      {/* Main stars */}
      {mainStars.length > 0 && (
        <div style={{ marginBottom: 4, display: "flex", flexWrap: "wrap", gap: 3 }}>
          {mainStars.map((star, i) => {
            const sihuaForStar = sihua.find(s => s.star === star || s.star_name === star);
            return (
              <span key={i} style={{
                fontSize: 11, fontWeight: 600,
                color: isSpecial ? "#846B32" : "#333",
              }}>
                {star}
                {sihuaForStar && <SihuaBadge sihua={sihuaForStar.sihua || sihuaForStar.transformation} />}
              </span>
            );
          })}
        </div>
      )}

      {/* Aux / sha stars */}
      {(auxStars.length > 0 || shaStars.length > 0) && (
        <div style={{
          fontSize: 10, color: "#9A8070",
          fontFamily: "sans-serif", marginBottom: 4,
        }}>
          {auxStars.length > 0 && (
            <span style={{ color: "#2D6A4F" }}>{auxStars.join(" ")}</span>
          )}
          {shaStars.length > 0 && (
            <span style={{ color: "#B91C1C", marginLeft: auxStars.length > 0 ? 4 : 0 }}>
              {shaStars.join(" ")}
            </span>
          )}
        </div>
      )}

      {/* Narrative */}
      {narrative && (
        <div style={{
          fontSize: 11, color: "#6B5540", lineHeight: 1.65,
          marginTop: 4,
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}>{narrative}</div>
      )}
    </div>
  );
}

function ZiweiPalaces({ ziwei_full, ziwei_interpretation, lang }) {
  if (!ziwei_full || !ziwei_full.palaces || ziwei_full.palaces.length === 0) return null;

  const palaces = ziwei_full.palaces;
  const narratives = ziwei_interpretation?.palace_narratives || {};

  return (
    <div>
      {/* Ming / Shen header */}
      {(ziwei_full.ming_gong || ziwei_full.shen_gong) && (
        <div style={{
          display: "flex", gap: 10, marginBottom: 16,
          flexWrap: "wrap",
        }}>
          {ziwei_full.ming_gong && (
            <div style={{
              background: "rgba(212,175,55,.08)",
              border: "1px solid rgba(212,175,55,.30)",
              borderRadius: 8, padding: "8px 14px",
              fontSize: 12, color: "#846B32",
            }}>
              <span style={{ fontWeight: 700 }}>命宫：</span>{ziwei_full.ming_gong?.palace_name || ziwei_full.ming_gong?.branch || ''}
              {ziwei_interpretation?.ming_narrative && (
                <span style={{ color: "#6B5540", marginLeft: 6, fontSize: 11 }}>
                  {ziwei_interpretation.ming_narrative.slice(0, 40)}…
                </span>
              )}
              {ziwei_interpretation?.ming_gong_text && (
                <div style={{fontSize:11,color:"#6B5540",marginTop:4}}>{ziwei_interpretation.ming_gong_text.slice(0,80)}…</div>
              )}
            </div>
          )}
          {ziwei_full.shen_gong && (
            <div style={{
              background: "rgba(59,130,246,.06)",
              border: "1px solid rgba(59,130,246,.25)",
              borderRadius: 8, padding: "8px 14px",
              fontSize: 12, color: "#1E40AF",
            }}>
              <span style={{ fontWeight: 700 }}>身宫：</span>{ziwei_full.shen_gong?.palace_name || ziwei_full.shen_gong?.branch || ''}
              {ziwei_interpretation?.shen_narrative && (
                <div style={{fontSize:11,color:"#6B5540",marginTop:4}}>{ziwei_interpretation.shen_narrative}</div>
              )}
            </div>
          )}
        </div>
      )}

      {/* 3×4 palace grid */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 10,
      }}>
        {palaces.map((palace, i) => (
          <PalaceCard
            key={i}
            palace={palace}
            narrative={narratives[palace.palace_name] || ""}
            lang={lang}
          />
        ))}
      </div>

      {/* Ziwei AI narrative summary */}
      {(ziwei_interpretation?.ming_gong_text || ziwei_interpretation?.sihua_text) && (
        <div style={{marginTop: 20}}>
          <div style={{fontSize: 13, fontWeight: 700, color: "#846B32", marginBottom: 8}}>
            紫微命盘深度解读
          </div>
          <div style={{fontSize: "13px", color: "#333", lineHeight: 1.8}}>
            {ziwei_interpretation?.ming_gong_text && (
              <p style={{marginBottom: 8}}>{ziwei_interpretation.ming_gong_text}</p>
            )}
            {ziwei_interpretation?.sihua_text && (
              <p style={{marginBottom: 8}}>{ziwei_interpretation.sihua_text}</p>
            )}
            {ziwei_interpretation?.sanfang_text && (
              <p style={{marginBottom: 8}}>{ziwei_interpretation.sanfang_text}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ZiweiPalaces;
